import { Text } from 'common-components'
import { RangeSlider } from 'common-components'
import StopWatchIcon from 'assets/svgr-icons/StopWatch.svg'
import { memo } from 'react'

import * as Styled from './styled'
import { translate } from 'utils/translations'
import { IEffectSliderProps } from './types'
import { AUDIO_EFFECT_STEP_COEFFICIENT } from 'utils/audio'

const step = 1 / 10 ** AUDIO_EFFECT_STEP_COEFFICIENT
const EffectSlider = ({
  value,
  onValueChange,
  label,
  duration
}: IEffectSliderProps) => {
  return (
    <Styled.VolumeSliderContainer>
      <Text type="h2">{translate(label)}</Text>
      <Styled.VolumeSliderWrapper>
        <RangeSlider
          onChange={event => {
            const value = parseFloat(event.target.value)
            onValueChange(value)
          }}
          isFullWidth
          value={Math.min(value, duration)}
          maxValue={duration}
          step={step}
        />

        <Styled.RightGroup>
          <Styled.ValueChip>{Math.min(value, duration)}</Styled.ValueChip>
          <StopWatchIcon />
        </Styled.RightGroup>
      </Styled.VolumeSliderWrapper>
    </Styled.VolumeSliderContainer>
  )
}

export default memo(EffectSlider)
